<template>
    <div class="tree-item">
      <div class="tree-item-content">
        <span 
          v-if="item.children && item.children.length" 
          class="toggle"
          @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? '−' : '+' }}
        </span>
        <span v-else class="toggle-spacer"></span>
        
        <label class="tree-label">
          <input
            ref="checkbox"
            type="checkbox"
            :checked="selected.includes(item.id)"
            @change="$emit('toggle', item.id)"
          />
          <span>{{ item.name }}</span>
        </label>
      </div>
      
      <div v-if="isExpanded && item.children" class="tree-children">
        <tree-item
          v-for="child in item.children"
          :key="child.id"
          :item="child"
          :selected="selected"
          @toggle="$emit('toggle', $event)"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TreeItem',
    props: {
      item: {
        type: Object,
        required: true
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
  data() {
    return {
      isExpanded: this.hasSelectedDescendants()
    };
  },
  computed: {
    isIndeterminate() {
      if (!this.item.children || !this.item.children.length) return false;
      if (this.selected.includes(this.item.id)) return false;
      return this.checkChildrenSelected(this.item.children);
    }
  },
  watch: {
    selected: {
      handler() {
        if (this.hasSelectedDescendants()) {
          this.isExpanded = true;
        }
        this.applyIndeterminate();
      },
      deep: true
    }
  },
  mounted() {
    this.applyIndeterminate();
  },
  methods: {
    applyIndeterminate() {
      this.$nextTick(() => {
        if (this.$refs.checkbox) {
          this.$refs.checkbox.indeterminate = this.isIndeterminate;
        }
      });
    },
    hasSelectedDescendants() {
      if (this.selected.includes(this.item.id)) {
        return true;
      }
      if (this.item.children && this.item.children.length) {
        return this.checkChildrenSelected(this.item.children);
      }
      return false;
    },
    checkChildrenSelected(children) {
      for (const child of children) {
        if (this.selected.includes(child.id)) {
          return true;
        }
        if (child.children && child.children.length) {
          if (this.checkChildrenSelected(child.children)) {
            return true;
          }
        }
      }
      return false;
    }
  }
  };
  </script>
  
  <style scoped>
  .tree-item {
    user-select: none;
  }
  
  .tree-item-content {
    display: flex;
    align-items: center;
    padding: 5px 0;
    gap: 5px;
  }
  
  .toggle {
    cursor: pointer;
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-weight: bold;
  }
  
  .toggle-spacer {
    width: 20px;
    display: inline-block;
  }
  
  .tree-label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }
  
  .tree-children {
    padding-right: 25px;
  }
  </style>